export const getCssVarValue = cssVar =>
  getComputedStyle(document.documentElement).getPropertyValue(cssVar);

const bodyClassList = document.querySelector('body').classList;

export const addBodyClass = classToAdd => bodyClassList.add(classToAdd);

export const removeBodyClass = classToRemove =>
  bodyClassList.remove(classToRemove);
